import { useEffect, useState } from 'react';
import { Box, Checkbox, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CloseIcon, PlusIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import InputDatepicker from 'UiKit/input-datepicker';
import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const InputPeakDay = ({ isEventDay, setValue, peakDays, maxDate, minDate }) => {
  const { t } = useTranslation('schedule-generate');

  const [excludeDates, setExcludeDates] = useState([]);
  const handleAddPeakDay = () => {
    const newPeakDays = [...peakDays, [null, null]];
    setValue('peakDays', newPeakDays);
  };

  const handleChangeDays = (dates, index) => {
    const newPeakDays = [...peakDays];
    newPeakDays[index] = dates;
    setValue('peakDays', newPeakDays);
  };

  const handleDeleteDays = (index) => {
    const newPeakDays = peakDays.filter((_, idx) => {
      return index !== idx;
    });
    setValue('peakDays', newPeakDays);
  };

  useEffect(() => {
    const tempExcludeDates = [];

    for (const peakDay of peakDays) {
      const [startDate, endDate] = peakDay;
      if (startDate && endDate) {
        const month = startDate.getMonth();
        const year = startDate.getFullYear();

        for (let i = startDate.getDate(); i <= endDate.getDate(); i++) {
          tempExcludeDates.push(new Date(year, month, i));
        }
      }
    }

    setExcludeDates(tempExcludeDates);
  }, [peakDays]);

  return (
    <Box className={styles['peakday__container']}>
      <Box width={'100%'}>
        <Checkbox
          checked={isEventDay}
          isChecked={isEventDay}
          onChange={(event) => {
            const checked = event.target.checked;
            setValue('isEventDay', checked);
            if (!checked) {
              setValue('peakDays', []);
            } else {
              setValue('peakDays', [[null, null]]);
            }
          }}
        >
          <TextRegular>{t('eventPeakDayAvailable')}</TextRegular>
        </Checkbox>
      </Box>
      <Condition statement={isEventDay}>
        <Box className={styles['peakday__container--content']}>
          <TextBold>{t('eventPeakDayDate')}</TextBold>
          <Box width={'100%'} className={styles['peakday__container--datepicker']}>
            <Iteration
              items={peakDays}
              render={(item, index) => {
                const [peakDayStartDate, peakDayEndDate] = item;
                return (
                  <Flex alignItems={'center'} gap={'12px'}>
                    <Box className={styles['peakday__input--datepicker']}>
                      <InputDatepicker
                        placeholder={t('fieldPeakDayPlaceholder')}
                        startDate={peakDayStartDate}
                        endDate={peakDayEndDate}
                        shouldCloseOnSelect={true}
                        selectsRange={true}
                        dateFormat="dd MMM"
                        minDate={minDate}
                        excludeDates={excludeDates}
                        maxDate={maxDate}
                        onChange={(peakDays) => handleChangeDays(peakDays, index)}
                        titleClassname={styles['form__text--label']}
                        className={'form__wrapper--datepicker'}
                        width="100%"
                        datepickerClassname={styles['form__container--datepicker']}
                      />
                    </Box>
                    <CloseIcon color="var(--color-primary60)" size="16px" className={styles['hosts__icon--delete']} onClick={() => handleDeleteDays(index)} />
                  </Flex>
                );
              }}
            />
          </Box>
          <Box className={styles['peakday__container--add']} onClick={handleAddPeakDay}>
            <PlusIcon color="var(--color-primary60)" size="16px" className={styles['hosts__icon--plus']} />
            <TextSemiBold className={styles['peakday__text--plus']}>{t('addDate')}</TextSemiBold>
          </Box>
        </Box>
      </Condition>
    </Box>
  );
};

export default InputPeakDay;
